'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Action = require('./Action.js');
var useIsMobile = require('../hooks/useIsMobile.js');
var Icons = require('./Icons.js');
var Details_module = require('./Details.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Details = props => {
  const isMobile = useIsMobile["default"]();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const [showNumber, setShowNumber] = React.useState(false);
  const {
    driver,
    type,
    color,
    status,
    layout,
    featureName
  } = props;
  const {
    driverDetailsCallButtonText,
    driverDetailsChatButtonText
  } = nthHookTranslations.useTranslations();
  const {
    bodytextDefaultNone,
    iconsPrimaryNone
  } = nthHookTheme.useTheme();
  if (!driver) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  const number = driver.contact ? driver.contact.proxyPhoneNumber : '';
  const onChat = () => {
    logEvent({
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.TEXTING_DRIVER,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.TEXTING_DRIVER,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS
    });
    if (isMobile) window.open(`sms:${number ?? ''}`);else setShowNumber(true);
  };
  const onCall = () => {
    logEvent({
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.CALLING_DRIVER,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.CALLING_DRIVER,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS
    });
    if (isMobile) window.open(`tel:${number ?? ''}`, '_top');else setShowNumber(true);
  };
  const showContact = status !== 'LDDELIVERED' && status !== 'HPUPICKEDUP';
  if (!driver.name && !number) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  const isLandscape = layout === nthKitDynamicLayoutNext.LayoutTree.FeatureLayout.LANDSCAPE;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: isLandscape ? Details_module["default"].containerLandscape : Details_module["default"].container
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Details_module["default"].infoContainer
  }, driver.photo && /*#__PURE__*/React__default["default"].createElement("img", {
    className: Details_module["default"].avatar,
    src: driver.photo,
    alt: ""
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: Details_module["default"].textContainer
  }, driver.name && /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    as: "h2",
    featureName: featureName
  }, driver.name), color && type && /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      ...bodytextDefaultNone
    }
  }, `${color} ${type}`))), showContact && layout === nthKitDynamicLayoutNext.LayoutTree.FeatureLayout.PORTRAIT && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      height: '24px'
    }
  }), showContact && number && /*#__PURE__*/React__default["default"].createElement("div", {
    className: Details_module["default"].contactContainer
  }, showNumber ? /*#__PURE__*/React__default["default"].createElement("p", {
    className: Details_module["default"].number
  }, number) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Action["default"], {
    featureName: featureName,
    icon: /*#__PURE__*/React__default["default"].createElement(Icons.Chat, {
      inlineStyle: iconsPrimaryNone
    }),
    text: driverDetailsChatButtonText,
    onClick: onChat
  }), /*#__PURE__*/React__default["default"].createElement(Action["default"], {
    featureName: featureName,
    icon: /*#__PURE__*/React__default["default"].createElement(Icons.Call, {
      inlineStyle: iconsPrimaryNone
    }),
    text: driverDetailsCallButtonText,
    onClick: onCall
  }))));
};
var Details$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(Details, {
  themeTokens: ['bodytextDefaultNone', 'iconsPrimaryNone']
}), {
  translationKeys: ['driverDetailsCallButtonText', 'driverDetailsChatButtonText']
});

exports["default"] = Details$1;
